import React from 'react';
import { Phone, Mail, ArrowRight, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { studioInfo, images } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with Circular Logo */}
      <div className="absolute inset-0 z-0 bg-slate-950">
        {/* Large Blurred Logo Watermark */}
        <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
          <img 
            src="/logo-circular.png"
            alt="FP Background"
            className="w-[1000px] h-[1000px] object-contain opacity-[0.08]"
            style={{ filter: 'blur(3px)', transform: 'scale(1.2)' }}
          />
        </div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/60 via-slate-900/70 to-slate-950/90"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 py-32">
        <div className="max-w-4xl">
          {/* Specialization Badge */}
          <div className="inline-flex items-center space-x-2 bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-2 mb-6">
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
            <span className="text-gray-300 text-sm font-medium">Especialistas en Derecho Penal</span>
          </div>

          {/* Main Title */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            FP Estudio <br />
            <span className="text-yellow-400">Jurídico</span>
          </h1>

          {/* Tagline */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl">
            {studioInfo.tagline}
          </p>

          {/* Description */}
          <p className="text-lg text-gray-400 mb-10 max-w-2xl leading-relaxed">
            {studioInfo.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-gray-700 hover:bg-gray-600 text-white text-lg px-8 py-6 group"
            >
              Consulta
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <a
              href="whatsapp://send?phone=5492236661214&text=Hola%2C%20necesito%20asesoramiento%20sobre%20mi%20caso%20que%20se%20trata%20de..."
              className="inline-block"
            >
              <Button 
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white text-lg px-8 py-6 w-full group"
              >
                <Phone className="mr-2" size={20} />
                Escribinos ahora
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
            </a>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col gap-3 text-gray-300">
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="tel:2236661214"
                className="flex items-center space-x-2 hover:text-blue-400 transition-colors group"
              >
                <div className="bg-blue-600/20 p-2 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                  <Phone size={20} />
                </div>
                <div>
                  <span className="font-medium">223 6661214</span>
                  <span className="text-gray-400 text-sm ml-2">Mar del Plata</span>
                </div>
              </a>
              <a 
                href="tel:2257632222"
                className="flex items-center space-x-2 hover:text-blue-400 transition-colors group"
              >
                <div className="bg-blue-600/20 p-2 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                  <Phone size={20} />
                </div>
                <div>
                  <span className="font-medium">2257 632222</span>
                  <span className="text-gray-400 text-sm ml-2">Pinamar, Gesell, La Costa</span>
                </div>
              </a>
            </div>
            <a 
              href={`mailto:${studioInfo.email}`}
              className="flex items-center space-x-2 hover:text-blue-400 transition-colors group"
            >
              <div className="bg-blue-600/20 p-2 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                <Mail size={20} />
              </div>
              <span className="font-medium">{studioInfo.email}</span>
            </a>
          </div>

          {/* Locations */}
          <div className="mt-6 flex items-center space-x-2 text-gray-400">
            <MapPin size={18} className="text-yellow-400" />
            <span className="text-sm">La Costa • Pinamar • Cariló • Gesell • Mar del Plata</span>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-slate-950 to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
